<template>
  <div class="loader-wrapper">
    <!-- <div class="loader-icon"></div> -->
    <div class="wrapper-svg-loader">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 224 104">
      <rect width="100%" height="100%" fill="black"/>
      <g id="koyama" stroke="white" fill="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <animate id="animation1"
                attributeName="opacity"
                from="1" to="0" dur="0.2s"
                begin="0.2s;animation2.end+1s" />
        <animate id="animation2"
                attributeName="opacity"
                from="0" to="1" dur="0.2s" 
                begin="animation1.end" />
        <path d="
          M 2 2
          L 22 2
          L 22 82
          L 2 102
          Z
        "></path>
        <path d="
          M 42 2
          L 62 2
          L 62 102
          L 42 102
          Z
        "></path>
        <path d="
          M 82 2
          L 102 2
          L 102 102
          L 82 82
          Z
        "></path>
        <path d="
          M 122 2
          L 142 2
          L 142 99
          L 162 99
          L 162 2
          L 182 22
          L 182 99
          L 202 99
          L 202 2
          L 222 2
          L 222 102
          L 122 102
          Z
        "></path>
      </g>
      <g id="jun" stroke="gray" fill="gray" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0">
        <animate id="animation3"
                attributeName="opacity"
                from="0" to="1" dur="0.2s"
                begin="0.2s;animation4.end+1s" />
        <animate id="animation4"
                attributeName="opacity"
                from="1" to="0" dur="0.2s" 
                begin="animation3.end" />
        <path d="
          M 24 2
          L 40 2
          L 40 102
          L 4 102
          L 24 82
          Z
        "></path>
        <path d="
          M 64 2
          L 80 2
          L 80 83
          L 104 102
          L 104 2
          L 120 2
          L 120 102
          L 64 102
          Z
        "></path>
        <path d="
          M 144 2
          L 200 2
          L 200 102
          L 184 102
          L 184 22
          L 160 2
          L 160 102
          L 144 102
          Z
        "></path>
      </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loader'
}
</script>

<style lang="scss" scoped>
  .loader-wrapper {
    width: 100%;
    height: 100vh;
    background-color: $primary;
    position: fixed;
    top: 0;
    left: 0;
    @include flex(center, center);
    z-index: 500;
  }

  .loader-icon {
    background-image: url("/src/assets/img/loader-koyama-logo.svg");
    width: 80px;
    height: 80px;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .wrapper-svg-loader {
    width: 80px;
    height: 80px;
  }
</style>